import { PauseIcon } from '@dicetechnology/doris-ui';
import css from 'classnames';
import * as React from 'react';

interface CoverProps {
    description?: string;
    paused: boolean;
    posterUrl?: string;
    title?: string;
    waiting: boolean;
}

const CoverLogo = ({ posterUrl }: { posterUrl: string }) => {
    return (
        <div className="cover__logo">
            <img src={posterUrl} alt="cover logo" />
        </div>
    );
};

export const Cover: React.FC<CoverProps> = ({ paused, waiting, title, description, posterUrl }: CoverProps) => {
    const className = css('cover', paused && 'cover--in', waiting && 'cover--hide');
    const hasTitleOrDescription = Boolean(title) || Boolean(description);

    return (
        <div className={className}>
            <div className="cover__overlay">
                {posterUrl && <CoverLogo posterUrl={posterUrl} />}
                <div className={css('cover__content', !hasTitleOrDescription && 'cover__content--pause')}>
                    {title && <h1>{title}</h1>}
                    {description && <p>{description}</p>}
                    {!hasTitleOrDescription && (
                        <div className="cover__play">
                            <PauseIcon />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
